import React from "react";
import { Grid, Box } from "@mui/material";
import CommonModal from "./CommonModal";
import './AddEditInterfaceModal.css';

interface AddEditInterfaceModalColumn {
  component: React.ReactNode;
  gridSize?: number;
}

interface AddEditInterfaceModalRow {
  columns: AddEditInterfaceModalColumn[];
}

interface AddEditInterfaceModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  layout: AddEditInterfaceModalRow[];
  saveText?: string;
  disableSave?: boolean;
  title?: string;
  maxWidth?: string;
  width?: string;
  cancelText?: string;
  onCancelSave?: () => void;
  syncProps?: {
    showSyncIcon: boolean,
    onSyncClick: () => void,
    isSyncing: boolean,
    setIsSyncing: React.Dispatch<React.SetStateAction<boolean>>;
  };
  showCancel?: boolean;
}

const AddEditInterfaceModal: React.FC<AddEditInterfaceModalProps> = ({
  open,
  onClose,
  onSave,
  layout,
  saveText = 'Update',
  disableSave = false,
  title = 'Add/Edit Interface',
  cancelText,
  onCancelSave,
  maxWidth,
  width,
  syncProps,
  showCancel = true
}) => {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      title={title}
      saveText={saveText}
      cancelText={cancelText ? cancelText : "Cancel"}
      showSyncStatus={false}
      onCancelSave={onCancelSave}
      disableSave={disableSave}
      maxWidth={maxWidth || "458px"}
      width={width || "700px"}
      showOnlineOffline={false}
      syncProps={syncProps}
      showCancel={showCancel}
    >
      <Box className="modal-scroll-container">
        {layout.map((row, rowIndex) => (
          <Grid container spacing={1.5} key={rowIndex} sx={{ mb: 1 }}>
            {row.columns.map((col, colIndex) => (
              <Grid item xs={col.gridSize ?? 12} key={colIndex}>
                {col.component}
              </Grid>
            ))}
          </Grid>
        ))}
      </Box>
    </CommonModal>
  );
};

export default AddEditInterfaceModal;
